import { useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { QueryKeys } from '../../core/queries/query-keys.constants';
import { fetchAllPages } from '../../core/queries/query-helpers';

// Note: in future we should move this file into a more general kiosk related folder
export function useQueryKiosksList() {
  const api = useApi();
  return useQuery([QueryKeys.KIOSKS], async () => {
    return await fetchAllPages(
      async (pageNo) =>
        await api.kiosksController.list({
          includeChildProjects: true,
          includeRemoved: false,
          includeInactive: true,
          includeAppearsOn: false,
          pageNo,
          perPageRecords: 500
        })
    );
  });
}

export function useQueryKiosksListByProjectID(
  projectID: string,
  options?: { includeChildProjects?: boolean; includeInactive?: boolean }
) {
  const api = useApi();
  return useQuery([QueryKeys.KIOSKS, projectID, options], async () => {
    return await fetchAllPages(
      async (pageNo) =>
        await api.kiosksController.list({
          projectID,
          includeChildProjects: options?.includeChildProjects ?? true,
          includeRemoved: false,
          includeInactive: options?.includeInactive ?? true,
          includeAppearsOn: false,
          pageNo,
          perPageRecords: 500
        })
    );
  });
}
